import { render, staticRenderFns } from "./TableDetailView.vue?vue&type=template&id=50235ef8&scoped=true"
import script from "./TableDetailView.vue?vue&type=script&lang=js"
export * from "./TableDetailView.vue?vue&type=script&lang=js"
import style0 from "./TableDetailView.vue?vue&type=style&index=0&id=50235ef8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50235ef8",
  null
  
)

export default component.exports